import { QueryResult, Reference } from '@apollo/client';
import { ContentLibrary } from '.';

interface ContentLibraryPagingArgs {
  offset: number;
  limit: number;
}

export type ContentLibraryCached = {
  rows: Reference[];
  totalCount: number;
};

export type ContentLibraryCachedResult = {
  value: ContentLibraryCached;
  variables?: ApiContentLibraryVars;
};

export interface ApiContentLibrary {
  id: number;
  answer: string;
  question: string;
}

export interface ApiContentLibraryArgs {
  question: string;
  pagination: ContentLibraryPagingArgs;
}

export interface ApiContentLibraryVars extends Omit<ApiContentLibraryArgs, 'pagination'>, ContentLibraryPagingArgs {}

export interface ApiContentLibraryResponseData {
  rows: ApiContentLibrary[];
  totalCount: number;
}

export interface ApiContentLibraryResponse {
  getRowsFromSimilarQuestionsTenjin: ApiContentLibraryResponseData;
}

export interface ContentLibraryResponseData
  extends Omit<QueryResult<ApiContentLibraryResponse, ApiContentLibraryVars>, 'data'> {
  data?: ContentLibrary;
  fetchingMore: boolean;
}

export const DEFAULT_CONTENT_LIBRARY_LIMIT = 6;
